import { render, staticRenderFns } from "./byId.vue?vue&type=template&id=416cc47f&scoped=true&"
import script from "./byId.ts?vue&type=script&lang=ts&"
export * from "./byId.ts?vue&type=script&lang=ts&"
import style0 from "./byId.vue?vue&type=style&index=0&id=416cc47f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "416cc47f",
  null
  
)

export default component.exports